import { render, staticRenderFns } from "./SpackageList.vue?vue&type=template&id=5c3c5530&"
import script from "./SpackageList.vue?vue&type=script&lang=js&"
export * from "./SpackageList.vue?vue&type=script&lang=js&"
import style0 from "./SpackageList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports